export const mapMetadaCurrency = (currency?: string | null) => currency?.replace('CURRENCY_', '');
